import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4" }
const _hoisted_2 = { class: "mt-1 text-sm text-gray-900 sm:text-right sm:mt-0 sm:col-span-2" }
const _hoisted_3 = {
  class: "flex-grow px-2 py-1 rounded-lg text-powder-800 bg-powder-100 hover:bg-powder-50",
  href: ""
}
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "absolute inset-0 z-10 bg-white/40 backdrop-blur-[0.5px] flex items-center justify-center text-sm font-semibold text-gray-700"
}
const _hoisted_8 = { class: "grid grid-cols-4 gap-6 mt-6" }
const _hoisted_9 = { class: "col-span-4" }
const _hoisted_10 = { class: "flex mt-1 rounded-md shadow-sm" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "py-3 mt-4 text-center" }
const _hoisted_13 = ["disabled"]

import {computed, defineComponent, onMounted, Ref, ref} from "vue";
import {client, trackEvent} from '@/shared';
import {
    GetProfileCustomUrl, GetProfileCustomUrlResponse,
    UpdateProfileCustomUrl,
} from "@/dtos";
import {ResponseStatus} from "@servicestack/client";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";
import {store} from "@/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileCustomUrlSettings',
  setup(__props) {

// @ts-ignore
const updateSuccessful: Ref<Boolean> = ref(false);
const responseStatus = ref(null);
const profile: Ref<GetProfileCustomUrlResponse> = ref({});


const isFetching = ref(true);
onMounted(async () => {
    await client.get<GetProfileCustomUrlResponse>(new GetProfileCustomUrl())
        .then(response => {
            profile.value = response;
            isFetching.value = false;
        });
});

const newUrl = ref("");

const submitNewProfileUrl = async () => {
    updateSuccessful.value = false;

    let request = {
        newUrl: newUrl.value
    };
    await client.post<ResponseStatus>(new UpdateProfileCustomUrl(request))
        .then(response => {
            updateSuccessful.value = true;
            responseStatus.value = null;

            trackEvent('profile_updated', {
                method: 'custom_url_updated',
                url: request.newUrl
            });
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
};

const isProMember = computed(() => {
    return store.saUserSession.subscriptionType === 'pro';
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", null, [
      _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "space-y-1" }, [
        _createElementVNode("h3", { class: "text-xl font-bold leading-6 text-gray-900" }, [
          _createTextVNode("StageAgent Profile URL "),
          _createElementVNode("sup", { class: "text-electric-700" }, "PRO")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-sm font-medium text-clay-800" }, "Your current profile link", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", _hoisted_3, [
            _cache[1] || (_cache[1] = _createTextVNode("https://stageagent.com/talent/")),
            _createElementVNode("span", _hoisted_4, _toDisplayString(profile.value.currentProfileUrl), 1)
          ])
        ])
      ]),
      (profile.value.hasCustomUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "mt-6" }, [
              _createElementVNode("p", { class: "mt-2 text-sm text-clay-800" }, "You have already changed your profile URL. You can only change your profile URL once.")
            ], -1)
          ])))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (isFetching.value)
              ? (_openBlock(), _createBlock(SkeletonCard, {
                  key: 0,
                  class: "mt-4",
                  "card-style": "long",
                  "num-of-cards": 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["relative", { 'pointer-events-none': !isProMember.value }])
            }, [
              (!isProMember.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[4] || (_cache[4] = [
                    _createElementVNode("span", { class: "text-electric-700" }, "PRO Only", -1)
                  ])))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", {
                    class: "block text-sm font-medium text-gray-700",
                    for: "newUrl"
                  }, "Choose your custom profile URL", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "inline-flex items-center px-3 border border-r-0 text-clay-800 border-clay-500 rounded-l-md bg-gray-50 sm:text-sm" }, " https://stageagent.com/talent/ ", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "newUrl",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newUrl).value = $event)),
                      disabled: !isProMember.value,
                      class: "flex-1 block w-full min-w-0 rounded-none border-clay-500 focus:ring-powder-500 focus:border-powder-500 rounded-r-md sm:text-sm",
                      name: "newUrl",
                      type: "text"
                    }, null, 8, _hoisted_11), [
                      [_vModelText, newUrl.value]
                    ])
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("p", { class: "mt-2 text-sm text-clay-800" }, "Careful! You can only change your profile URL once.", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "submit",
                  onClick: _withModifiers(submitNewProfileUrl, ["prevent"]),
                  disabled: !isProMember.value,
                  class: _normalizeClass([
                  'w-full inline-flex items-center justify-center px-4 py-[calc(theme(spacing.2)-1px)] rounded-full border shadow-md whitespace-nowrap text-base font-medium',
                  isProMember.value 
                    ? 'bg-clay-950 text-clay-100 hover:bg-clay-900 hover:text-clay-50 border-transparent'
                    : 'bg-gray-300 text-gray-600 cursor-not-allowed'
                ])
                }, " Save custom profile URL ", 10, _hoisted_13)
              ])
            ], 2)
          ]))
    ]),
    _createVNode(NotificationSuccess, {
      show: updateSuccessful.value,
      content: "Your changes were successfully saved.",
      title: "Successfully saved!"
    }, null, 8, ["show"])
  ], 64))
}
}

})